import { render, staticRenderFns } from "./PaymentManage.vue?vue&type=template&id=2d84f814&"
import script from "./PaymentManage.vue?vue&type=script&lang=js&"
export * from "./PaymentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports